import React from 'react';
import { ChildProps } from 'react-apollo';
import I18n from 'i18n-js';
import { Item2PaymentOptionsData } from '../schemas/rql';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import gql from 'graphql-tag';
import { trackEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';
import { displayPaymentMethod } from '../lib/payment_method_icons';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { filterBuyerPaymentMethods } from '../lib/klarnaExperiments';

interface ExternalProps extends IUserContext {
  listingId: string;
}

type IProps = ChildProps<ExternalProps, Item2PaymentOptionsData.Query>;

function isAcceptedPaymentMethodsEnabled(user) {
  return isExperimentEnabled(user, experiments.ACCEPTED_PAYMENT_METHODS);
}

export function Item2PaymentOptions(props: IProps) {
  const { user, listingId } = props;
  const componentName = 'Item2PaymentOptions';

  if (!isAcceptedPaymentMethodsEnabled(user)) return null;

  if (!props.data || props.data.loading) return null;

  const acceptedPaymentMethods = filterBuyerPaymentMethods(props.data.listing?.acceptedPaymentMethods, user);

  trackEvent({
    eventName: MParticleEventName.ViewedListingAcceptedPaymentMethods,
    componentName,
    listingId,
    paymentMethodsAvailable: acceptedPaymentMethods.sort().join('|'),
  });

  return (
    <div className="item2__sidebar-module">
      <div className="item2__sidebar-module__header">
        {I18n.t('discovery.paymentOptions.accepts')}
      </div>
      <div
        className="d-flex fx-wrap"
        style={{ margin: '0 -0.5rem -0.5rem' }}
      >
        {acceptedPaymentMethods.map(paymentMethod => {
          const display = displayPaymentMethod(paymentMethod);
          if (!display) return null;
          return display.icons.map(cardIcon => {
            return (
              <div key={`${cardIcon.text}`} className="mlr-half mb-half">
                <img
                  style={{ width: '4rem' }}
                  src={cardIcon.source}
                  alt={cardIcon.text}
                />
              </div>
            );
          });
        })}
      </div>
    </div>
  );
}

const withQuery = withGraphql<IProps, Item2PaymentOptionsData.Query>(
  gql`
    query Item2_Payment_Options_Data(
      $listingId: String
    ){
      listing(
        input: {id: $listingId}
      ){
        _id
        acceptedPaymentMethods
      }
    }
  `,
  {
    skip: ownProps => !isAcceptedPaymentMethodsEnabled(ownProps.user),
    options: (ownProps) => {
      return {
        ssr: false,
        errorPolicy: 'all',
        variables: {
          listingId: ownProps.listingId,
        },
      };
    },
  },
);

export default withUserContext(withQuery(Item2PaymentOptions));
